import { IconSize } from '../Icons/IconWrap';
export const getIconSizeForButtonSize = (buttonSize)=>buttonSize === 'small' ? IconSize.SMALLER : IconSize.MEDIUM;
